import { RevisionRow } from 'components/tables/data/revision/types';
import RevisionStatusIcon from 'components/RevisionStatusIcon';

/**
 * Column for the revision status.
 */
export default function RevisionStatusColumn({ data: { revisionStatus, kind } }: { data: RevisionRow }) {
  return <RevisionStatusIcon statusId={revisionStatus.revisionStatusId} kind={kind} />;
}
